import { mapState } from 'vuex';
import get from 'lodash/get';
import { localizeDate } from '@/utils/date';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
import formMixin from '../formMixin';
const defaultItemsPerPage = 15;
export default {
  name: 'NiotaClassicConsumersIec104Metrics',
  mixins: [formMixin],
  props: {
    consumer: {
      type: undefined,
      required: true
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      lclObject: {},
      dialogAdd: false,
      selectedApplication: null,
      isFetching: null,
      metrics: [],
      latestMetrics: null,
      tableHeaders: [{
        text: this.$i18n_t('NiotaClassic.Consumers.detail.port'),
        value: 'data.port',
        align: 'left'
      }, {
        text: this.$i18n_t('Common.status'),
        value: 'data.status',
        align: 'left'
      }, {
        text: this.$i18n_t('NiotaClassic.Consumers.detail.lastCC'),
        value: 'data.lastConfigChange',
        align: 'left'
      }, {
        text: this.$i18n_t('NiotaClassic.Consumers.detail.lastDU'),
        value: 'data.lastDataUpdate',
        align: 'left'
      }, {
        text: this.$i18n_t('NiotaClassic.Consumers.detail.connections'),
        value: 'data.numConnectedClients',
        align: 'left'
      }],
      tableOptions: {
        sortBy: ['id'],
        sortDesc: [false],
        itemsPerPage: defaultItemsPerPage
      },
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    tableHeadersUI() {
      let res = this.tableHeaders;
      if (this.dense) {
        res.splice(1, 1);
      }
      return res;
    }
  },
  created() {
    this.isFetching = true;
    // TODO: Currently pagination is not working! just first page!
    NiotaClassicApiService.consumersGetMetrics(this.consumer.externalId, 1).then(res => {
      this.metrics = res.data.metrics;
      this.latestMetrics = this.metrics.length ? this.metrics[0] : null;
    }).catch(error => {
      // TODO: create toast with error message
      console.error('Could not fetch consumer metrics', error);
    }).finally(() => {
      this.isFetching = false;
    });
  },
  methods: {
    localizeDate,
    get
  }
};